import { Component, Input, OnDestroy, OnInit, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { WebcastModel } from 'rev-portal/scheduledEvents/webcast/model/WebcastModel';

import { formatTimespanShort } from 'rev-shared/date/DateFormatters';
import { SecondMs } from 'rev-shared/date/Time.Constant';

@Component({
	selector: 'vb-webcast-vod-timer',
	templateUrl: './VbWebcastVodTimer.Component.html',
	standalone: false
})
export class VbWebcastVodTimer implements OnInit, OnDestroy {
	@Input() public webcast: WebcastModel;

	@Output() public onTimerEnd: EventEmitter<void> = new EventEmitter();

	public countdownTimeSeconds: number;
	public vodProgressSeconds: number;
	public countdownTimerInterval: number;
	public vodProgressDisplay: string = '';
	public countdownTimeDisplay: string;

	constructor(
		private readonly translateService: TranslateService
	) {}

	public ngOnInit(): void {
		this.countdownTimerInterval = window.setInterval(this.updateTimer.bind(this), 1000);
	}

	public ngOnDestroy(): void {
		window.clearInterval(this.countdownTimerInterval);
	}

	public updateTimer(): void {
		if (this.webcast.webcastStatus.isInProgress) {
			this.updateLobbyTimer();
		} else if (this.webcast.webcastStatus.isBroadcasting) {
			this.updateBroadcastProgress();
		}
	}

	private updateLobbyTimer(): void {
		this.countdownTimeSeconds = this.webcast.startDate.getTime() - Date.now();
		this.countdownTimeDisplay = this.countdownTimeSeconds > 0 ?
			this.translateService.instant('Event_AutomatedWebcast_BroadcastWillBegin', { '0': `${formatTimespanShort(this.countdownTimeSeconds, true, true)}` }) :
			this.translateService.instant('Event_StartingBroadcast');
	}

	private updateBroadcastProgress(): void {
		const start = new Date(this.webcast.broadcastTime).getTime();
		const durationMs = this.webcast.vodInfo.durationMs + 30 * SecondMs;
		const end = start + durationMs;
		this.countdownTimeSeconds = start + durationMs - Date.now();
		this.vodProgressSeconds = durationMs - this.countdownTimeSeconds;
		this.vodProgressDisplay = `${formatTimespanShort(this.vodProgressSeconds, true, true)}/${formatTimespanShort(durationMs, true, true)}`;
		if (Date.now() >= end) {
			window.clearInterval(this.countdownTimerInterval);
			this.onTimerEnd.emit();
		}
	}
}
